import React, { useState, useMemo } from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import SuggestedResults from './SuggestedResults';
import UseData from '../../utilities/useData';
import FollowUpView from './FollowUpView';

const QuickSearch = ({
    navigateUrl
}) => {
    const editUrl = '/customers/edit/';
    const searchUrl = '/api/customers/quickSearch/';

    const { data, setData, setUrl } = UseData();
    const [selectedItem, setSelectedItem] = useState(-1);

    function searchRecords(text) {
        if (text !== undefined && text.length > 2) {
            setUrl(searchUrl + encodeURIComponent(text));
        } else {
            setData(undefined);
            setUrl(undefined); //reset url in case same text comes next;
        }
    }

    const keyDown = (e) => {
        if (e.keyCode === 38) {
            const nextItem = selectedItem > -1 ? selectedItem - 1 : selectedItem;
            setSelectedItem(nextItem);
            e.preventDefault();
        } else if (e.keyCode === 40) {
            const nextItem = selectedItem < data.length - 1 ? selectedItem + 1 : selectedItem;
            setSelectedItem(nextItem);
            e.preventDefault();
        } else if (e.keyCode === 13 && selectedItem > -1) {
            navigateUrl(editUrl + data[selectedItem].id);
        }
    };

    return (
        <Row>
            <Col>
                <Row className="justify-content-center">
                    <Col className="quick-search-box dashboard-container">
                        <Row>
                            <Col>
                                <div className="quick-search-bar d-flex">
                                    <div className="search-button">
                                        <img src="/images/magnifier.svg" />
                                    </div>
                                    <input className="search-input"
                                        autoComplete="off"
                                        onChange={e => searchRecords(e.target.value)}
                                        onKeyDown={(e) => keyDown(e)}
                                        placeholder="Quick Search"
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            {useMemo(() =>
                            (
                                <SuggestedResults
                                    editCustomer={(id) => navigateUrl(editUrl + id)}
                                    keyDown={keyDown}
                                    results={data}
                                    selectedItem={selectedItem}
                                />
                            ), [data, selectedItem])}
                        </Row>
                    </Col>
                </Row>
                <Row>
                    {window.biztrax.showFollowUps &&
                        <FollowUpView />
                    }
                </Row>
            </Col>
        </Row>
    );
}

export default QuickSearch;